import React from 'react';
import cx from 'classnames';
import { ResourceQtiDataDto } from '../../apis/ocs-api-service/ocs-api-service.dtos';
import { ELSIcon } from '../els.components';

export interface OrderQuestionsDisplayProps {
  question: ResourceQtiDataDto;
  selectedAnswers?: string[];
  rationaleBlockTitle?: JSX.Element;
  questionId?: string;
}

const getCorrectOrder = (correctResponse, selectedAnswer: string): number => {
  if (correctResponse && selectedAnswer) {
    const formattedCorrectResponse: string[] = Array.isArray(correctResponse[0]) ? correctResponse.flat() : correctResponse as string[];
    return formattedCorrectResponse.indexOf(selectedAnswer) + 1;
  }
  return null;
};

export const OrderQuestionDisplay = (props: OrderQuestionsDisplayProps) => {
  const {
    question,
    selectedAnswers,
    rationaleBlockTitle,
    questionId
  } = props;

  const { correctResponse } = question;
  const { responseChoices } = question;

  const displayOrderQuestions = selectedAnswers || correctResponse;
  const testIdPrefix = questionId ? `ssa-order-question-${questionId}` : 'ssa-order-question';

  return (
    <div>
      <h4
        role="presentation"
        className="o-els-container u-els-margin-top c-ssa-disable-text-selection question-prompt__content question-prompt__content--selection"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: question.prompt }}
        data-testid={`${testIdPrefix}-prompt`}
      />
      <ul className="c-ssa-reorder c-ssa-disable-text-selection">
        {
          (displayOrderQuestions as string[])
            .map((questionItem, index) => {
              const isCorrect = questionItem === correctResponse[index];
              return (
                <li className="c-ssa-reorder__row" key={JSON.stringify(questionItem)} data-testid={`${testIdPrefix}-item-${questionItem}`}>
                  <div className="o-els-flex-layout o-els-flex-layout--gutters">
                    <div className="o-els-flex-layout__item">
                      <div className="c-ssa-reorder__context">
                        <div className="o-els-flex-layout o-els-flex-layout--middle o-els-flex-layout--left o-els-flex-layout--gutters">
                          <div className="o-els-flex-layout__item">
                            <div className={cx('c-ssa-answer-icon c-ssa-answer-icon--visible', {
                              'c-ssa-answer-icon--correct': isCorrect,
                              'c-ssa-answer-icon--incorrect': !isCorrect,
                            })}>
                              <ELSIcon
                                name={isCorrect ? 'checkmark' : 'close'}
                                prefix="hmds"
                                size="1x"
                              />
                            </div>
                          </div>
                          <div className="o-els-flex-layout__item">
                            <div className="c-ssa-reorder__number">{index + 1}.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="o-els-flex-layout__item o-els-flex-layout__item--grow">
                      <div className="c-ssa-reorder__item">
                        <div className="o-els-flex-layout o-els-flex-layout--middle o-els-flex-layout--gutters">
                          <div className="o-els-flex-layout__item o-els-flex-layout__item--grow">
                            <h4
                              className="c-ssa-reorder__text"
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{ __html: responseChoices[questionItem] }}
                              data-testid={`${testIdPrefix}-item-text-${questionItem}`}
                            />
                          </div>
                          <ELSIcon
                            name="drag-handle"
                            size="2x"
                            prefix="hmds"
                          />
                        </div>
                      </div>
                      {!isCorrect && (
                        <div className="c-ssa-reorder__feedback" data-testid={`${testIdPrefix}-item-feedback-${questionItem}`}>
                          <div className="u-els-italic u-els-bold u-els-color-warn">
                            Correct order: {getCorrectOrder(correctResponse, questionItem)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              );
            })
        }
      </ul>

      <h4 className="u-els-margin-top-4x c-ssa-disable-text-selection" data-testid={`${testIdPrefix}-rationale`}>
        <div className="u-els-font-family-bold u-els-margin-top">
          {rationaleBlockTitle}
        </div>
        {/* eslint-disable-next-line react/no-danger */}
        <p className="rationale__text" dangerouslySetInnerHTML={{ __html: question.feedback.feedback }} />
      </h4>
      <p className="u-els-margin-top u-els-font-family-italic c-ssa-disable-text-selection" data-testid={`${testIdPrefix}-reference`}>
        {question.textReference}
      </p>

    </div>
  );
};
